import { getAnnuityFactor } from "shared/getAnnuityFactor";
import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const calcPerpetualRentTotal = (monthly: number): number => {
	if (monthly <= 0) return 0;
	return Math.round((monthly * 12) / GOAL_REAL_YIELD);
};

export const calcRentToZeroTotal = (monthly: number, years: number): number => {
	if (monthly <= 0 || years <= 0) return 0;
	return Math.round(
		monthly * getAnnuityFactor(GOAL_REAL_YIELD / 12, years * 12),
	);
};

export const calcPerpetualRentMonthly = (total: number): number => {
	if (total <= 0) return 0;
	return Math.round((total * GOAL_REAL_YIELD) / 12);
};

export const calcRentToZeroMonthly = (total: number, years: number): number => {
	if (total <= 0 || years <= 0) return 0;
	return Math.round(total / getAnnuityFactor(GOAL_REAL_YIELD / 12, years * 12));
};
